import * as Sentry from '@sentry/browser'
import ConfigService from './ConfigService'
import axios from 'axios'
import { get as ldGet } from 'lodash'
import redirect from '@/utils/redirect'

const axiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

axiosInstance.interceptors.response.use(function (response) {
  // custom response code sent by server to indicate
  // gateway is in maintenance mode
  if (response.status === 299) {
    redirect.redirectTo(ConfigService.mantenanceLogoutUrl())
  }
  return response
}, function (error) {
  Sentry.configureScope((scope) => {
    scope.setTag('X-B3-TraceId', ldGet(error, 'response.headers[x-b3-traceid]', 'NONE'))
  })
  return Promise.reject(error)
})

class HttpService {
  constructor () {
    this.defaultErrorHandler = this.handleError
  }

  get (url, { errorHandler = this.defaultErrorHandler } = {}) {
    return new Promise(function (resolve, reject) {
      axiosInstance.get(url).then(function (res) {
        resolve(res)
      }).catch(function (err) {
        errorHandler(err)
        reject(err)
      })
    })
  }

  delete (url, { errorHandler = this.defaultErrorHandler } = {}) {
    return new Promise(function (resolve, reject) {
      axiosInstance.delete(url).then(function (res) {
        resolve(res)
      }).catch(function (err) {
        errorHandler(err)
        reject(err)
      })
    })
  }

  post (url, payload, { errorHandler = this.defaultErrorHandler } = {}) {
    return new Promise(function (resolve, reject) {
      axiosInstance.post(url, payload).then(function (res) {
        resolve(res)
      }).catch(function (err) {
        errorHandler(err)
        reject(err)
      })
    })
  }

  patch (url, payload, { errorHandler = this.defaultErrorHandler } = {}) {
    return new Promise(function (resolve, reject) {
      axiosInstance.patch(url, payload).then(function (res) {
        resolve(res)
      }).catch(function (err) {
        errorHandler(err)
        reject(err)
      })
    })
  }

  handleError (err) {
    if (!err.response) {
      return
    }
    if (err.response.status === 401) {
      redirect.redirectTo(ConfigService.reauthorizeUrl())
      return
    }
    if (err.response.status === 403) {
      const redirectUrl = window.location.protocol + '//' + window.location.host + '/403'
      redirect.redirectTo(redirectUrl)
    }
  }
}

export default new HttpService()
